"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var coreHeaderSkin = (function (clientShortHandName) {
    var _a;
    return ((_a = {},
        _a[types_1.ClientShortHandName.SA] = 'sa',
        _a[types_1.ClientShortHandName.AP] = 'ap',
        _a[types_1.ClientShortHandName.ASK] = 'avavis',
        _a[types_1.ClientShortHandName.BTI] = 'bt',
        _a[types_1.ClientShortHandName.BYN] = 'bnytt',
        _a[types_1.ClientShortHandName.STR] = 'stri',
        _a[types_1.ClientShortHandName.VNY] = 'vnytt',
        _a[types_1.ClientShortHandName.VG] = 'vg',
        _a[types_1.ClientShortHandName.DP] = 'e24',
        _a)[clientShortHandName]);
});
exports.default = coreHeaderSkin;
//# sourceMappingURL=coreHeaderSkin.js.map